export default __webpack_public_path__ + "static/media/light-photo.e42a57cb.png";